import React  from 'react'
import PropTypes from 'prop-types'

import DatepickerComponent from "core/gd-components/datetime/datepicker/datepicker"

import Moment from "moment"

export default function DeadlineInList(props) {

    const value = props.item.deadline ? Moment(props.item.deadline) : null;

    const classes = Classes('gd-field-deadline list', props.className, {
        'with-delete-button': props.deleteButton,
        'disabled'          : props.disabled
    })

    const onDeleteClick = (e) => {
        if (e) e.stopPropagation()
        props.onChange(null)
    }

    return (
        <div className={classes}>
            <DatepickerComponent skin               = "list"
                                 value              = {value}
                                 onSelect           = {props.onChange}
                                 minDate            = {Moment()}
                                 markPastdue        = {props.markPastdue}
                                 placeholderText    = "Deadline"
                                 disabled           = {props.disabled}/>

            {!props.disabled && !!value &&
                <div className="reset-button" onClick={onDeleteClick}>
                    <div className="ui5-ico-delete s14 gray"/>
                </div>}
        </div>
    )
}

DeadlineInList.propTypes = {
    item: PropTypes.object,

    markPastdue: PropTypes.bool,
    disabled: PropTypes.bool,

    onChange        : PropTypes.func
}